// extracted by mini-css-extract-plugin
export default {"block":"base-blocks_block__34u1e"};